import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { chapters } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Chapters() {
  return <section aria-labelledby="capitulos-title" className="w-full bg-ink-800" data-id="element-32" data-mp="2yzu6enldocpn">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-33" data-mp="2z1wu30z25tr7">
        <div className="max-w-3xl" data-id="element-34" data-mp="32zkugjjiseqh">
          <SectionLabel data-id="element-35" data-mp="33308rk5ddjqu">El sistema completo</SectionLabel>
          <h2 id="capitulos-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-36" data-mp="2p8zb6tq5m2s2">
            Los 4 pilares del método para entender y manejar la carrera futbolística de tu hijo
          </h2>
        </div>
        <div className="mt-10 space-y-5" data-id="element-37" data-mp="2kbpnpjmbs16v">
          {chapters.map(chapter => <article key={chapter.number} className="flex flex-col gap-5 rounded-xl border border-ink-border border-l-[5px] border-l-brand-green bg-ink-card p-6 shadow-panel transition-colors duration-150 ease-out hover:border-brand-green/50 hover:border-l-brand-green sm:flex-row md:p-8" data-id="element-38" data-mp="26ad9bcmtc7n3">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-greenDeep font-display text-xl font-black text-brand-greenSoft" data-id="element-39" data-mp="2fga19c875n41">
                {chapter.number}
              </div>
              <div data-id="element-40" data-mp="2oijalyrqbafu">
                <h3 className="font-display text-xl font-bold text-white md:text-2xl" data-id="element-41" data-mp="20s5cprmgqhdc">
                  {chapter.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-42" data-mp="1vu3t95l4kg1c">{chapter.description}</p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-43" data-mp="2aj0b1uczh7f5">
                  {chapter.tags.map(tag => <li key={tag} className="rounded-full bg-brand-greenDeep px-3 py-1 text-xs font-semibold text-brand-greenSoft" data-id="element-44" data-mp="25qgoi7wbj1y7">
                      {tag}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
        <div className="mt-8 flex items-start gap-4 rounded-xl border border-brand-gold/30 bg-brand-gold/[0.07] p-6" data-id="element-45" data-mp="3i3nist86jlpa">
          <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-46" data-mp="3mudne48s7kix" />
          <p className="text-sm leading-relaxed text-body" data-id="element-47" data-mp="3qwh0exb3mx6b">
            <span className="font-bold text-brand-gold" data-id="element-48" data-mp="3qy1uklti4e3n">Importante:</span> Este método es informativo
            y educativo para padres de futbolistas. No reemplaza el asesoramiento legal, médico ni
            deportivo profesional.
          </p>
        </div>
      </div>
    </section>;
}